module.exports = __webpack_public_path__ + "fonts/nexa_regular.43af9a82.otf";